import { useQuery } from "@tanstack/react-query";
import type { ReleasesDto } from "@hisense/shared";
import { apiFetch } from "@/lib/api";
import type { BrowserBuild } from "@/lib/releaseState";
export const browserBuild: BrowserBuild = {
  id: __APP_RELEASE_ID__,
  version: __APP_VERSION__,
  mode: __APP_BUILD_MODE__,
};
export function useReleases(page = 1) {
  return useQuery({
    queryKey: ["releases", browserBuild.id, page],
    queryFn: () =>
      apiFetch<ReleasesDto>("/releases", {
        query: { loadedId: browserBuild.id, page, pageSize: 25 },
      }),
    staleTime: 30000,
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
    retry: 1,
  });
}
